import React from 'react';

export const PlayerShopLink = ({track}) => {
    const url = 'https://tangiblemusic.bandcamp.com/music'
    return (
        <a href={url} target="_blank" className="player-shop-link">go to shop</a>
    );
}